<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester ssystem college department sclass keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.category" id="category" label="補助類別">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in categorys" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>班級</th>
                            <th>學號-學生姓名</th>
                            <th>補助類別</th>
                            <th>弱勢補助/學校自籌/教育部補助金額</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.DisadvantagedID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.DisadvantagedID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.DisadvantagedID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="補助類別">{{item.Category|category}}</td>
                        <td data-th="弱勢補助/學校自籌/教育部補助金額">{{item.Amount}}/{{item.SchoolAmount}}/{{item.EduAmount}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="category">
                <div is="option" v-for="o in categorys" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
        <inputmodal id="input" sample="/template/disadvantaged.xlsx" url="/api/disadvantaged/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './disadvantagedDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'disadvantaged',
        api: '/api/disadvantaged/',
        components: { Detail },
        data: { categorys: [] },
        created: function () {
            window.categorys = [];
            this.$parameter.disadvantaged().then((res) => { window.categorys = this.categorys = res.data; });
        },
        filters: {
            category: function (value) { let a = window.categorys.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; }
        },
    });
</script>

<style>
</style>